import React from "react";
import {HelpBlock, Input, Button, Modal} from "rsuite";
import ColdFireReactRef from "../common/ColdFireReactRef";

class NewPageNameModal extends React.Component {
    constructor(_props) {
        super(_props);

        this.state = {
            open: false,
            name: ""
        }

        this.show = this.show.bind(this);
        this.close = this.close.bind(this);
        this.onHide = this.onHide.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onNameChanged = this.onNameChanged.bind(this);
    }

    static getReference() {
        return new ColdFireReactRef(["show"]);
    }

    show(_callback) {
        return this.setState(() => {
            return {
                open: true,
                name: "",
                callback: _callback
            };
        });
    }

    close() {
        return this.setState(() => {
            return {
                open: false,
                callback: null };
        });
    }

    onNameChanged(_val) {
        return this.setState(()=> {
            return {name: _val};
        });
    }

    onSave() {
        if(typeof this.state.callback === "function") {
            this.state.callback(true, this.state.name);
        }
        this.close();
    }

    onCancel() {
        if(typeof this.state.callback === "function") {
            this.state.callback(false);
        }
        this.close();
    }

    onHide() {
        this.onCancel();
    }

    render() {
        return (
            <Modal show={this.state.open} size={"xs"} onHide={this.onHide}>
                <Modal.Header>
                    <Modal.Title>
                        New Page
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <HelpBlock>
                        Please enter the name of the new page
                    </HelpBlock>
                    <Input placeholder={"Enter page name..."} type={"text"} value={this.state.name} onChange={this.onNameChanged} />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.onSave} appearance="primary">
                        Create Page
                    </Button>
                    <Button onClick={this.onCancel} appearance="subtle">
                        Cancel
                    </Button>
                </Modal.Footer>

            </Modal>
        );
    }
}

export default NewPageNameModal;